import { VuexModule, Module, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store/store';
import { Controller, Counter, ControllerLog /*, CounterLog*/ } from '../models';
import { getControllers, getControllerLog, /*, getCounterLog*/
getControllerCounters} from '../api';

@Module({
  name: 'controllers',
  namespaced: true,
  dynamic: true,
  store,
})
class ControllersModule extends VuexModule {
  public controllers: Controller[] = [];
  public counters: Map<number, Counter[]> = new Map();
  public controllersLogs: ControllerLog[] = [];

  get getCounters() {
    return this.counters;
  }

  get getControllers() {
    return this.controllers;
  }

  get getControllersLogs() {
    return this.controllersLogs;
  }

  @Mutation
  public clean() {
    this.counters = new Map();
    this.controllers = [];
    this.controllersLogs = [];
  }

  @Mutation
  public setControllers(controllers: Controller[]) {
    controllers.sort((a, b) => a.id - b.id);
    this.controllers = controllers;
  }

  @Mutation
  public setCounters(args: {id: number, counters: Counter[]}) {
    args.counters.sort((a, b) => a.id - b.id);
    this.counters.set(args.id, args.counters);
  }

  @Mutation
  public updateControllerLog(log: ControllerLog) {
    let updated: boolean = false;
    this.controllersLogs.forEach((el) => {
      if (el.id === log.id) {
        el = log;
        updated = true;
      }
    });
    if (!updated) {
      this.controllersLogs.push(log);
    }
  }

  @Action({commit: 'setControllers'})
  public async refreshControllers(uid: number): Promise<Controller[]> {
    return await getControllers(uid);
  }

  @Action({commit: 'updateControllerLog'})
  public async getControllerLog(params: {uid: number, id: number}): Promise<ControllerLog> {
    return await getControllerLog(params.uid, params.id);
  }

  @Action({commit: 'setCounters'})
  public async getControllerCounters(params: {uid: number, id: number}): Promise<{id: number, counters: Counter[]}> {
    return await getControllerCounters(params.uid, params.id);
  }
}

export default getModule(ControllersModule);
